import React, { useState } from "react";

import { ErrorMessage, SingleSelect, Text, Textfield } from "widgets";
import PaymentModes from "components/PaymentModes/PaymentModes";

import styles from "./DirectPayment.module.scss";

const AMOUNT_TYPES = [
  {
    key: 1,
    label: "Full Amount",
    value: "Full Amount",
  },
  {
    key: 2,
    label: "Custom Amount",
    value: "Custom Amount",
  },
];
const FULL_AMOUNT = "Full Amount";
const CUSTOM_AMOUNT = "Custom Amount";
const CUSTOM_AMOUNT_INDEX = 1;

const getDefaultSelected = (totalAmount, payableAmount) => {
  if (totalAmount === payableAmount) {
    return FULL_AMOUNT;
  }
  return CUSTOM_AMOUNT;
};

const getPayableAmount = (
  amountType,
  payableAmount,
  customAmount,
  totalAmount,
  headAmount,
  isDownpayment
) => {
  if (amountType === FULL_AMOUNT) {
    return totalAmount;
  }
  if (isDownpayment) {
    return payableAmount;
  }
  if (amountType === CUSTOM_AMOUNT) {
    if (headAmount) {
      return Number(customAmount);
    }
    if (customAmount) {
      return Number(customAmount);
    }
  }
  return customAmount;
};
const getPaymentTypeId = (amountType, isDownpayment) => {
  if (isDownpayment) {
    return AMOUNT_TYPES[CUSTOM_AMOUNT_INDEX].key;
  }
  return AMOUNT_TYPES.find((type) => type.value === amountType)?.key;
};

const handleAmountTypeChange = (
  event,
  setAmountType,
  setCustomAmount,
  setPaymentLink
) => {
  const selectedValue = event.target.value;
  setAmountType(selectedValue);
  setCustomAmount("");
  setPaymentLink("");
};

const DirectPayment = ({
  totalAmount,
  payableAmount,
  orderId,
  salesPersonId,
  firstPaymentCollectionAmount,
  paymentFlowTypeId,
  isDownpayment,
  selectedOrderVerticalId,
}) => {
  const [amountType, setAmountType] = useState(
    getDefaultSelected(totalAmount, payableAmount)
  );
  const [customAmount, setCustomAmount] = useState("");
  const [paymentLink, setPaymentLink] = useState("");
  const paymentTypeId = getPaymentTypeId(amountType, isDownpayment);

  return (
    <div className={styles.onlinePaymentContainer}>
      {!isDownpayment ? (
        <div className={styles.field}>
          <Text>Select Amount Type</Text>
          <SingleSelect
            handleChange={(event) =>
              handleAmountTypeChange(
                event,
                setAmountType,
                setCustomAmount,
                setPaymentLink
              )
            }
            value={amountType}
            defaultSelected={amountType}
            menuItems={
              totalAmount === payableAmount
                ? AMOUNT_TYPES
                : [AMOUNT_TYPES[CUSTOM_AMOUNT_INDEX]]
            }
          />
        </div>
      ) : (
        <div className={styles.field}>
          <SingleSelect
            value={CUSTOM_AMOUNT}
            menuItems={[AMOUNT_TYPES[CUSTOM_AMOUNT_INDEX]]}
            disabled
          />
        </div>
      )}
      <div className={styles.field}>
        <Text>Payment Amount</Text>
        <Textfield
          value={
            isDownpayment
              ? payableAmount
              : amountType === CUSTOM_AMOUNT
              ? customAmount
              : amountType === FULL_AMOUNT
              ? totalAmount
              : ""
          }
          disabled={amountType === FULL_AMOUNT || isDownpayment}
          handleOnChange={(event) => {
            const value = event.target.value;
            const validAmount = value
              .replace(/[^0-9.]/g, "")
              .replace(/(\..*?)\..*/g, "$1");

            setCustomAmount(validAmount);
            setPaymentLink("");
          }}
          label="Enter Custom Amount"
        />
        {amountType === CUSTOM_AMOUNT &&
          firstPaymentCollectionAmount &&
          Number(customAmount) < Number(firstPaymentCollectionAmount) && (
            <ErrorMessage>
              Please collect an amount more than or equal to {firstPaymentCollectionAmount} INR
            </ErrorMessage>
          )}

        {isDownpayment ? (
          payableAmount > 0
        ) : amountType === CUSTOM_AMOUNT && !firstPaymentCollectionAmount && !customAmount ? (
          <ErrorMessage>Please enter a valid number</ErrorMessage>
        ) : null}
      </div>
      <PaymentModes
        orderId={orderId}
        amountToBePaid={getPayableAmount(
          amountType,
          payableAmount,
          customAmount,
          totalAmount,
          firstPaymentCollectionAmount,
          isDownpayment
        )}
        createdBy={salesPersonId}
        paymentLink={paymentLink}
        setPaymentLink={setPaymentLink}
        paymentTypeId={paymentTypeId}
        paymentFlowTypeId={paymentFlowTypeId}
        firstPaymentCollectionAmount={firstPaymentCollectionAmount}
        selectedOrderVerticalId={selectedOrderVerticalId}
      />
    </div>
  );
};

export default DirectPayment;
